// extracted by mini-css-extract-plugin
export default {"form_container":"SearchForm_form_container__OORTN","btn-delete":"SearchForm_btn-delete__GHYGB","btn-search":"SearchForm_btn-search__xFLif","gl-gap-10":"SearchForm_gl-gap-10__eQhlA"};